module.exports = __webpack_public_path__ + "static/media/ios_small_banner.c94ceaaa.jpg";